// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3vmRt","info":"Note_info__2wpKC","note":"Note_note__2ly4y","actions":"Note_actions__28u5f"};